// Packages
import { useState, useEffect } from "react";
import { Link, withRouter, useLocation, useHistory } from "react-router-dom";
import { includes, map, get } from "lodash";

// materila Ui
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";

import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";

// Assets

import ClickAwayListener from "@material-ui/core/ClickAwayListener";
// Assets
import { FaEnvelope, FaNewspaper, FaVideo, FaTachometerAlt, FaSchool, FaDatabase, FaMoneyBillWave, FaGlobe  } from "react-icons/fa"; // or any icon set you prefer

import {
  getFromLocalStorage,
  removeFromLocalStorage,
} from "../../utils/webStorage";

// style
import "./superAdmin.css";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },

  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    color: "white",
    background: "#01173E",
  },
  drawerContainer: {
    overflow: "auto",
  },
  dropdownbutton: {
    margin: theme.spacing(1),
    background: "#003594",
    color: "#FFFFFF",
    borderRadius: "22px",
    width: "80%",
    fontFamily: "Rajdhani-SemiBold",
  },

  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },

  dropdown: {
    position: "absolute",
    right: 0,
    left: "8px",
    zIndex: 1,
    padding: theme.spacing(0, 1),
    backgroundColor: "#003594",
    width: "80%",
    top: "108px",
    color: "#FFFFFF",
    borderRadius: "22px",
    textAlign: "center",
    fontFamily: "Rajdhani-SemiBold",
  },
  innerdropdown: {
    color: "#FFFFFF",
    fontFamily: "Rajdhani-SemiBold",
  },
  grow: {
    flexGrow: 1,
    textAlign: "right",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },

  inputRoot: {
    color: "inherit",
    background: "orange",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  tabs: {
    background: "#003594",
  },
}));

const MiniDrawer = (props) => {
  const textProfile = {
    color: "black",
    textAlign: "right",
  };
  const { history } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [UserName, setUserName] = useState(null);
  const [adminRole, setadminRole] = useState(null);
  const [hideShow, setHideShow] = useState(false);
  const [logImage, setLogImage] = useState("");
  const lolcation = useLocation();
  const isMenuOpen = Boolean(anchorEl);
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    var UserName = getFromLocalStorage("loginUser");
    var adminRole = getFromLocalStorage("loginRole");
    var loginUserProfile = getFromLocalStorage("loginUserProfile");
    setUserName(UserName);
    setadminRole(adminRole);
    setLogImage(loginUserProfile);
  }, []);

  function logout() {
    removeFromLocalStorage("user");
    window.localStorage.clear();
    history.push("/login");
  }

  const menuId = "primary-search-account-menu";
  const currentRoute = useHistory().location.pathname.toLowerCase();

  const itemsList = [
    {
      text: "Dashboard",
      icon: <FaTachometerAlt className="left-menu-icon" />,
      path: "/dashboarddata",
      liname: "dashboarddata",
    },
    {
      text: "Schools",
      icon: <FaSchool className="left-menu-icon"/>,
      path: "/schools",
      liname: "schools",
    },
    {
      text: "Storage",
      icon: <FaDatabase className="left-menu-icon" />,
      path: "/storage",
      liname: "storage",
    },
    {
      text: "Payments",
      icon: <FaMoneyBillWave className="left-menu-icon" />,
      path: "/payment",
      liname: "payment",
    },
    {
      text: "Website",
      icon: <FaGlobe className="left-menu-icon" />,
      path: "/website",
      liname: "website",
    },
    {
      text: "Live Streams",
      icon: <FaVideo className="left-menu-icon" />,
      path: "/liveStreamStatus",
      liname: "livestreamstatus",
    },

    {
      text: "Contact Us",
      icon: <FaEnvelope className="left-menu-icon" />,
      path: "/admincontactus",
      liname: "admincontactus",
    },

    {
      text: "NewsLetter",
      icon: <FaNewspaper className="left-menu-icon" />,
      path: "/adminnewsletter", 
      liname: "adminnewsletter",
    },
    // {
    //   text: "Breakdown Requests",
    //   icon: <img src={breakdownIcon} alt="breakdown"></img>,
    //   path: "/breakdownRequests",
    //   liname: "breakdownRequests",
    // },
  ];

  const classes = useStyles();
  const [, setOpen] = useState(false);

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  const renderMenu = (
    <Menu
      className="mt30"
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
      <MenuItem onClick={logout}>Logout</MenuItem>
    </Menu>
  );

  const sideBarShowHide = (data) => {
    setHideShow(data);
  };

  const [activeItem, setActiveItem] = useState("");

  const handleSelectClick = (path, text) => {
    setActiveItem(text);
    history.push(path);
  };
  return (
    <div>
      {!hideShow && (
        <div id="hideSAdminDash" className={classes.root}>
          <CssBaseline />

          {!includes(
            [
              // "/add-school",
              "/editschooladmin",

              "/editschooldetails",
              "/videolibrary",
            ],
            get(lolcation, "pathname")
          ) ? (
            <Drawer
              id="superAdminSidebar"
              className={classes.drawer}
              variant="permanent"
              classes={{
                paper: classes.drawerPaper,
              }}
            >
              <div className="clear100"></div>

              <ClickAwayListener className="p-0" onClickAway={handleClickAway}>
                <div className={classes.root}></div>
              </ClickAwayListener>

              <List>
                {map(itemsList, (item, index) => {
                  const path = get(item, "path");
                  const liname = get(item, "liname");
                  return (
                    <div className="h-40" id="schoolFeed" key={index}>
                      <ListItem
                        id={item.text}
                        className={
                          currentRoute.includes(liname)
                            ? "super-li-active"
                            : "super-Dashboard-listt-items" &&
                              activeItem == item.text
                            ? "select-color"
                            : ""
                        }
                        button
                        onClick={() => handleSelectClick(path, item.text)}
                      >
                        {item.icon && (
                          <ListItemIcon className="mng-icons">
                            {item.icon}
                          </ListItemIcon>
                        )}
                        <ListItemText primary={item.text} />
                      </ListItem>
                    </div>
                  );
                })}
              </List>
            </Drawer>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default withRouter(MiniDrawer);
